import { render, staticRenderFns } from "./_task_attachements.vue?vue&type=template&id=441c81af&scoped=true"
import script from "./_task_attachements.vue?vue&type=script&lang=js"
export * from "./_task_attachements.vue?vue&type=script&lang=js"
import style0 from "./_task_attachements.vue?vue&type=style&index=0&id=441c81af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c81af",
  null
  
)

export default component.exports